import styled from 'styled-components';
import {
    Label,
    Text,
} from '@zillow/constellation';

export const StyledUppercaseText = styled(Text)`
    text-transform: uppercase;
`;

export const StyledLabel = styled(Label)`
    margin-bottom: ${props => props.theme.ns().spacing.xs()};
`;
